import { OutlinedInputClassKey } from "@mui/material";
import { OverridesStyleRules } from "@mui/material/styles/overrides";

export const outlinedInputStyles: Partial<OverridesStyleRules<OutlinedInputClassKey>> = {
    root: {},
};
